import clsx from "clsx";

// Tabs: an underline 2px --accent-solid on the active one (design-system: Tabs).
function Tabs({ tabs, active, onChange, label }) {
  return (
    <div role="tablist" aria-label={label} className="flex gap-6 border-b border-[#e2e2e2]">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={active === tab.id}
          onClick={() => onChange(tab.id)}
          className={clsx(
            "-mb-px border-b-2 pb-2 text-sm",
            active === tab.id ? "border-cyan-450 font-medium text-[#14171a]" : "border-transparent text-[#8c8c8c] hover:text-[#14171a]",
          )}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}

export default Tabs;
